export default "__VITE_ASSET__C9fQgt3x__"